import React from "react";
import './Admin.css';
import FeedbackDataService from "../../services/feedback.service";
import SignupDataService from "../../services/signup.service";
import moment from "moment";


  class AdminFeedback extends React.Component{

    constructor(props) {
      super(props);
      const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
      let userid = 0;
    
      if(isLoggedIn)
      {
      userid = window.localStorage.getItem("userid");
  
      }
      this.state = {
        list: [],
        feedbackLookup: [{id: 0, value: ""},{id: 1, value: "Suggestions"}, {id: 2, value: "Testimonials"}, {id: 3, value: "Comments"}, {id: 4, value: "Helpdesk"}, {id: 5, value: "Bugs"}, {id: 6, value: "Reason"}]
  
      };
    }

    componentDidMount() {

      FeedbackDataService.getAll()
      .then(res => {
          if(res.data !== '')
          {
           
            res.data.forEach(res1 => {
              SignupDataService.get(res1.userid)
              .then(result => {

                var data = {
                  id: res1.userid,
                  feedback: res1.feedback,
                  name: result.data.name,
                  category:  this.state.feedbackLookup[res1.category].value,
                  createdAt : moment(res1.createdAt).format('LLL'),
                  email: result.data.email
                 
              }
  
  
              this.setState({
                list: [
                ...this.state.list,
                 data
                ]
              }); 
              });
             

            })

          }
         
          
      })
    }

    render(){
      return (
    <div className="row col-md-12">
        {
            this.state.list !== []  && this.state.list.length > 0 ?
            <div>
            <table responsive className="table">
            <thead>
              <tr>
                <td>Feedback</td>
                <td>Category</td>
                <td>Id</td>
                <td>Name</td>
                <td>Email</td>
                <td>Created</td>
                <td></td>
                </tr>
            </thead>
            <tbody>
            {
            this.state.list.map((log,index) => (
                        <tr key={index+"top_key"}>
                        <td key={index + "_a"} className="table-text-color">{log.feedback}</td>  
                        <td key={index + "_b"} className="table-text-color">{log.category}</td>  
                        <td key={index + "_c"} className="table-text-color">{log.id}</td> 
                        <td key={index + "_d"} className="table-text-color">{log.name}</td> 
                        <td key={index + "_e"} className="table-text-color">{log.email}</td> 
                        <td key={index + "_f"} className="table-text-color">{log.createdAt}</td>   
                       
                      </tr>
                                   
                    ))
            }
            </tbody>
            </table>
            </div>
         
          : <span className="table-text-color">No Feedback Messages found</span>

        }
    </div>
    
      )
      }
}



export default AdminFeedback;